import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Logo from '../../global/img/logo_full_white.png';
import { X_AUTH_ERROR, X_AUTH_EXCHANGE } from '../../store/constants';
import { appendReturnUrl, getXAuthErrorMessage, parseXCallbackParams } from '../../utils/xAuth';
import '../GoogleAuthButton/style.css';
import '../Signup/style.css';

const initialViewState = {
	status: 'loading',
	message: 'Finishing your X sign-in... please wait.',
	returnUrl: '/'
};

function XAuthCallback() {
	const dispatch = useDispatch();
	const userActions = useSelector((state) => state.userActions);
	const [viewState, setViewState] = useState(initialViewState);

	useEffect(() => {
		const { exchangeCode, error, returnUrl } = parseXCallbackParams(window.location.search);

		if (error) {
			const message = getXAuthErrorMessage(error);
			dispatch({
				type: X_AUTH_ERROR,
				payload: { message }
			});
			setViewState({
				status: 'error',
				message,
				returnUrl
			});
			return;
		}

		if (!exchangeCode) {
			const message = getXAuthErrorMessage('missing_exchange_code');
			dispatch({
				type: X_AUTH_ERROR,
				payload: { message }
			});
			setViewState({
				status: 'error',
				message,
				returnUrl
			});
			return;
		}

		setViewState({
			status: 'loading',
			message: initialViewState.message,
			returnUrl
		});
		dispatch({
			type: X_AUTH_EXCHANGE,
			payload: {
				exchangeCode,
				returnUrl
			}
		});
	}, [dispatch]);

	useEffect(() => {
		const nextMessage = userActions?.message?.message || userActions?.message;
		if (userActions?.xAuthError && nextMessage) {
			setViewState((currentState) => ({
				...currentState,
				status: 'error',
				message: nextMessage
			}));
		}
	}, [userActions?.message, userActions?.xAuthError]);

	return (
		<section className='signupMainSection'>
			<div className='signupMainDiv'>
				<img src={Logo} alt='Inside Injuries Logo' className='signupLogo' />
				<p className='signupHeaderText'>{viewState.status === 'loading' ? 'Connecting X' : 'X Sign-In Unavailable'}</p>
				<div className='signupFormDiv' style={{ textAlign: 'center' }}>
					<p className='loginFlowText' style={{ display: 'block', marginBottom: 24 }}>
						{viewState.message}
					</p>
					{viewState.status === 'loading' ? (
						<div className='googleAuthLoadingOverlay' style={{ position: 'static', minHeight: 72 }}>
							Redirecting...
						</div>
					) : (
						<>
							<a href={appendReturnUrl('/login', viewState.returnUrl)} className='loginButton' style={{ display: 'inline-flex', justifyContent: 'center', textDecoration: 'none', marginBottom: 14 }}>
								Back to Login
							</a>
							<p className='loginFlowText'>
								Need a new account?
								<a href={appendReturnUrl('/signup', viewState.returnUrl)} className='loginFlowLink ps-2'>
									Join for free
								</a>
							</p>
						</>
					)}
				</div>
			</div>
		</section>
	);
}

export default XAuthCallback;
